
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/liability-insurance/cyber-insurance",
      function () {
        return require("private-next-pages/products/liability-insurance/cyber-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/liability-insurance/cyber-insurance"])
      });
    }
  